import axios from "../axios/AxiosInstance";
import { apiErrorMessage } from "../utils/apiError";

const BASE = "facture/freelance-to-agency";

export async function loadFreelanceInvoices() {
  const { data } = await axios.get(BASE);
  if (Array.isArray(data)) return data;
  throw new Error("Format de réponse du suivi des factures non reconnu.");
}

export async function createFreelanceInvoice({ number, amount, issued, due, comment, file }) {
  const form = new FormData();
  form.append("numeroFacture", number);
  form.append("montant", String(amount));
  form.append("dateEmission", issued);
  form.append("dateEcheance", due);
  if (comment) form.append("description", comment);
  form.append("file", file);
  const { data } = await axios.post(BASE, form);
  return data;
}

export async function getFreelanceInvoiceFile(id) {
  const { data } = await axios.get(`${BASE}/${id}/file`);
  const bytes = Uint8Array.from(atob(data.data), (c) => c.charCodeAt(0));
  return new File([bytes], data.name || "facture.pdf", { type: data.type || "application/pdf" });
}

export async function setFreelanceInvoicePayment(id, paidAmount) {
  const { data } = await axios.patch(`${BASE}/${id}/payment`, { paidAmount });
  return data;
}

export async function deleteFreelanceInvoice(id) {
  await axios.delete(`${BASE}/${id}`);
}

export function freelanceInvoiceError(error) {
  if (error?.response?.status === 401)
    return apiErrorMessage(error, "Votre session a expiré. Reconnectez-vous pour consulter vos factures.");
  if (error?.response?.status === 403)
    return apiErrorMessage(error, "Votre compte n’est pas autorisé à consulter ces factures. Contactez l’agence.");
  if (!error?.response && error?.message === "Format de réponse du suivi des factures non reconnu.")
    return error.message;
  if (!error?.response)
    return "Connexion au serveur de l’agence impossible. Vérifiez votre connexion puis actualisez.";
  return apiErrorMessage(error, "Le serveur de l’agence ne peut pas charger vos factures. Réessayez plus tard.");
}
